<template>
  <div>
    <span v-show="isOn" class="material-icons" ref="close">close</span>
    <div v-if="isOn" class="bg">
        <component :is="component" :data="data"/>
    </div>
  </div>
</template>

<script>
import BMButton from '@/components/BlackMoonUI/BMButton'
export default {
    props: ['isOn', 'component', 'data'],
    components: {
        BMButton
    },
    mounted(){
        setTimeout(() => {
            this.$refs.close.addEventListener('click', () => {
                console.log('close button clicked')
                this.closeModal()
            })
            console.log('mounted')
        }, 300)
    },
    methods: {
        closeModal(){
            console.log('closing')
            this.$modal.dismiss()
        }
    }
}
</script>

<style lang="scss" scoped>
    .bg {
        background-color: $transparentDark;
        z-index: 100;
        height: vh(100);
        width: 100vw;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center; 
    }

    .material-icons {
        color: white;
        font-size: 2.3rem;
        position: fixed;
        top: 5px;
        right: 5px;
        z-index: 9999;
    }
</style>